import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class RMDashboardService {  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }
  

  getPMTaskDetailsDash(data: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-rm-dashboard', { params: data });
    return this.http.post<any>(this.O3CoreApiUrl + 'RMDashboard/GetPMTaskDetailsDash', data);
  }

  // failed PM checklist answers only
  getPMChecklistExceptionReport(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'RMDashboard/GetPMChecklistExceptionReport', data);
  }

  // Checklist Compliance KPI - same stored function as the exception report
  getPMChecklistComplianceKPI(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'RMDashboard/GetPMChecklistComplianceKPI', data);
  }

  getRMDashboardData(data: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-rm-dashboard', { params: data });
    return this.http.get<any>(this.O3CoreApiUrl + 'RMDashboard/GetDashboardRM', { params: data });
  }

  // getMachinesByLine(data: any): Observable<any[]> {
  //   return this.http.get<any>(this.baseUrl + 'get-rm-machines', {
  //     params: data,
  //   });
  // }

  getTableData(data: any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-table-unit', { params: data });
    return this.http.get<any>(this.O3CoreApiUrl + 'RMDashboard/getTableUnit', { params: data });
  }

  //NOT IN USE
  // getComponentByMachine(data: any): Observable<any[]> {
  //   return this.http.get<any>(this.baseUrl + 'get-rm-component', {
  //     params: data,
  //   });
  // }
  getMainKPIDashboard(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'RMDashboard/GetMainKPIDash', {
      ...data,
    });
  }
}
